import { Checkbox, FormControlLabel, Box, Typography } from "@mui/material";

const CustomCheckboxLabel = ({
  label,
  checked,
  onChange,
  disabled,
  formControlLabelStyle = {},
  formControlLabelTextStyle = {},
  icon,
  checkedIcon,
  dark = false,
  size = "18px",
}) => {
  return (
    <FormControlLabel
      sx={{ mr: "0px", opacity: disabled ? 0.5 : 1, ...formControlLabelStyle }}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          icon={
            icon ? (
              icon
            ) : (
              <img
                src="/icons/checked-icons/checkbox-uncheck-icon.svg"
                alt="checkbox-uncheck-icon"
                width={size}
                height={size}
              />
            )
          }
          checkedIcon={
            checkedIcon ? (
              checkedIcon
            ) : dark ? (
              <img
                src="/icons/checked-icons/checkbox-checked-darkGreen-icon.svg"
                alt="checkbox-checked-icon"
                width={size}
                height={size}
              />
            ) : (
              <img
                src="/icons/checked-icons/checkbox-checked-lightGreen-icon.svg"
                alt="checkbox-checked-icon"
                width={size}
                height={size}
              />
            )
          }
        />
      }
      label={
        label ? (
          <Box>
            <Typography
              color="rgba(62, 63, 76, 1)"
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
                ...formControlLabelTextStyle,
              }}
            >
              {label}
            </Typography>
          </Box>
        ) : (
          <></>
        )
      }
    />
  );
};

export default CustomCheckboxLabel;
